import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Linkedin: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-540v-540h465c41.36 0 75 33.64 75 75zm-210-30h180v-435c0-24.81-20.19-45-45-45h-435v480z' />
    <path d='m544.65 539.92h-68.79v-110.95c0-26.84-7.1-45.08-31.12-45.08-18.35 0-28.23 12.32-32.97 24.26-1.81 4.28-2.26 10.13-2.26 16.15v115.61h-69.1l-.42-204.21h69.14l.38 28.82c8.84-13.65 23.57-32.97 58.76-32.97 43.69 0 76.31 28.51 76.31 89.78v118.57h.07zm-272.27-230.91h-.38c-22.28 0-36.66-15.35-36.66-34.5s14.83-34.43 37.53-34.43 36.59 14.83 37.04 34.43c0 19.15-14.45 34.5-37.53 34.5m35.82 230.91h-68.2l-.38-204.21h68.2z' />
  </IconBase>
));

Linkedin.displayName = 'Linkedin';

export default Linkedin;
